/**
 * Removes all class attributes from every node in an SVG snippet
 * @param svgSnippet - The SVG snippet string to sanitize
 * @returns The sanitized SVG snippet with all class attributes removed
 */
const sanitizeSvgSnippet = (svgSnippet) => {
  const parser = new DOMParser()
  try {
    const doc = parser.parseFromString(svgSnippet, 'text/html')

    // Get all elements and remove class attributes
    const allElements = doc.querySelectorAll('*')
    allElements.forEach((element) => {
      element.removeAttribute('class')
    })
    return doc.body.innerHTML
  } catch (error) {
    console.error('Error parsing SVG snippet:', error)
    return svgSnippet // Return original snippet if parsing fails
  }
}

export default sanitizeSvgSnippet